module.exports = __webpack_public_path__ + "media/assets/images/flags/um-da6f48767abd7fff5b85784cbaf7fa18.svg";